var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55,
    zoomAndPan: "magnify",
    viewBox: "0 0 41.25 41.250001",
    height: 55,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "87d7044dea"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: 6099587810
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#87d7044dea)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.125,
    width: 49.5,
    fill: "#000000",
    y: -4.125,
    height: 49.500001,
    fillOpacity: 0.498
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "06f1fac9e0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.53125 0.742188 L 23.453125 0.742188 L 23.453125 10.34375 L 0.53125 10.34375 Z M 0.53125 0.742188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fb9429ac0b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 24,
    y: 0,
    height: 11
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e470458d17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.816406 21.238281 L 27.652344 21.238281 L 27.652344 30.835938 L 4.816406 30.835938 Z M 4.816406 21.238281 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#6099587810)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 13, 12)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fb9429ac0b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#06f1fac9e0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffde59",
    d: "M 23.453125 5.542969 L 18.625 0.746094 L 18.625 4.34375 L 0.53125 4.34375 L 0.53125 6.742188 L 18.625 6.742188 L 18.625 10.339844 Z M 23.453125 5.542969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e470458d17)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffde59",
    d: "M 4.734375 26.035156 L 9.558594 21.238281 L 9.558594 24.835938 L 27.652344 24.835938 L 27.652344 27.234375 L 9.558594 27.234375 L 9.558594 30.835938 Z M 4.734375 26.035156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPlay);
export default __webpack_public_path__ + "static/media/arrow-play.e9e994799ee74a980f17403c5bfab4a5.svg";
export { ForwardRef as ReactComponent };